import { render, staticRenderFns } from "./SneakIntoBasketAndRoachMotel.vue?vue&type=template&id=64dcb54c&"
import script from "./SneakIntoBasketAndRoachMotel.vue?vue&type=script&lang=ts&"
export * from "./SneakIntoBasketAndRoachMotel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports